var _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeakerImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "organize-yourself-speaker",
    width: 227,
    height: 220,
    viewBox: "0 0 227 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1519_27220)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.17 109.324C136.559 125.02 138.516 145.678 129.511 163.732C116.088 190.644 83.3903 201.579 56.4784 188.156C47.6206 183.738 40.4937 177.231 35.3964 169.531C25.0071 153.835 23.0498 133.177 32.0548 115.123C45.4778 88.2109 78.1758 77.2761 105.088 90.6991C113.945 95.1172 121.072 101.623 126.17 109.324Z",
    fill: "#462C9A",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8828 161.191C34.9801 168.892 42.107 175.398 50.9648 179.816L56.4828 188.156C47.6251 183.738 40.4981 177.232 35.4009 169.531L29.8828 161.191Z",
    fill: "#462C9A",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.998 155.392C133 137.345 131.047 116.695 120.667 101.001L126.174 109.324C136.564 125.02 138.521 145.678 129.516 163.732L123.998 155.392Z",
    fill: "#462C9A",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.961 179.814C77.8729 193.237 110.571 182.302 123.994 155.391L129.512 163.73C116.089 190.642 83.3909 201.577 56.4791 188.154L50.961 179.814Z",
    fill: "#462C9A",
    fillOpacity: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.2674,
    cy: 131.088,
    r: 54.4532,
    transform: "rotate(26.509 75.2674 131.088)",
    fill: "url(#paint0_linear_1519_27220)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.5724 82.3595C108.43 86.7776 115.557 93.2837 120.654 100.984L126.172 109.324C121.075 101.623 113.948 95.1173 105.09 90.6992L99.5724 82.3595ZM99.5721 82.3594C72.6603 68.9363 39.9623 79.8712 26.5393 106.783L26.5392 106.783C17.5342 124.837 19.4916 145.495 29.8809 161.191L35.388 169.514C25.0082 153.82 23.0554 133.17 32.0573 115.123L32.0573 115.123C45.4804 88.2109 78.1783 77.2761 105.09 90.6991L99.5721 82.3594Z",
    fill: "#462C9A",
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.38
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7586 120.394C100.224 121.066 100.304 121.94 99.9667 122.688L96.1848 131.078C98.6248 132.219 100.331 134.328 101.064 136.745C101.699 138.837 101.609 141.172 100.641 143.319C99.6728 145.467 97.9929 147.059 96.0213 147.932C93.7436 148.941 91.0611 148.998 88.6212 147.858L84.8393 156.248C84.5023 156.995 83.8 157.504 82.9959 157.582C82.1917 157.66 81.4074 157.297 80.9372 156.628L71.0567 142.57L66.4728 152.739C65.9507 153.898 64.6053 154.406 63.4679 153.874L55.2302 150.022C54.0927 149.49 53.594 148.12 54.1162 146.962L58.8434 136.474C56.5686 135.411 55.5711 132.67 56.6155 130.353L62.2882 117.769C63.3325 115.452 66.0232 114.436 68.298 115.499L80.1078 121.021L97.7063 119.426C98.5109 119.353 99.2928 119.722 99.7586 120.394ZM73.091 138.057C73.4494 138.224 73.7587 138.484 73.9882 138.811L82.3496 150.707L94.2186 124.376L79.9101 125.673C79.5173 125.709 79.1222 125.639 78.7638 125.472L66.4071 119.694L60.7344 132.279L73.091 138.057ZM62.9623 138.4L59.1805 146.79L63.2994 148.716L67.0812 140.326L62.9623 138.4ZM90.5121 143.663C91.7318 144.233 93.0677 144.207 94.2132 143.699C95.2018 143.261 96.037 142.469 96.5219 141.394C97.0068 140.318 97.0522 139.156 96.734 138.107C96.3652 136.892 95.5136 135.843 94.2939 135.273L90.5121 143.663Z",
    fill: "#2F095F",
    fillOpacity: 0.69
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.74
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9954 163.737C34.7079 134.052 32.7047 85.366 61.5211 54.994C90.3375 24.6221 139.061 24.0653 170.349 53.7504C201.636 83.4355 203.64 132.121 174.823 162.493C146.007 192.865 97.283 193.422 65.9954 163.737Z",
    fill: "url(#paint1_radial_1519_27220)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1519_27220",
    x: 20.8047,
    y: 76.6211,
    width: 141.445,
    height: 143.273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 16,
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1519_27220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1519_27220",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1519_27220",
    x1: 108.568,
    y1: 69.8614,
    x2: 51.018,
    y2: 185.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A08AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7551FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1519_27220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(118.172 108.744) rotate(133.495) scale(56.8308 78.0921)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7551FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerImage);
export default __webpack_public_path__ + "static/media/SpeakerImage.6bee9ca70fd2acb04958599ac0677641.svg";
export { ForwardRef as ReactComponent };